// extracted by mini-css-extract-plugin
export default {"wrapper":"FsSPZ_n3LbCsqCpoxZGu","logo":"PTADhe5QAoZurctb5boe","fieldset":"BBKg9GC0kcGRUAYR4tl1","button":"PL6a5yQyBoyHOfcEYvhk","error":"lyedlpo3q4MyDX6_iDU8"};